import React from 'react'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import SubnavBar from 'Components/Shared/SubnavBar'

type Props = {
  activity: any
  name?: any
  onClose?: () => void
}

const Breadcrumbs: React.ComponentType<Props> = props => {
  const { activity, name, onClose = () => {} } = props
  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: '/report/auditroad',
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: '/report/auditroad',
      title: 'รายงานถนน',
      active: true,
      showTitle: true,
    },
    {
      url: '/report/auditroad',
      title: 'ตรวจรับมอบถนนและก่อนหมดประกัน',
      active: false,
      showTitle: false,
    },
  ]

  return <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
}

export default Breadcrumbs
